import { render, staticRenderFns } from "./NgsTab.vue?vue&type=template&id=c713823e&"
import script from "./NgsTab.vue?vue&type=script&lang=js&"
export * from "./NgsTab.vue?vue&type=script&lang=js&"
import style0 from "./NgsTab.vue?vue&type=style&index=0&id=c713823e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports